(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[720],{

/***/ "h6Iw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationLargeSubNavList", function() { return NavigationLargeSubNavList; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Navigation_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("1cDg");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("i5Mr");
/* harmony import */ var _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("NJJ8");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;






var NavigationLargeSubNavList = function NavigationLargeSubNavList(_ref) {
  var _ref$subItems = _ref.subItems,
      subItems = _ref$subItems === void 0 ? [] : _ref$subItems;

  if (Object(lodash__WEBPACK_IMPORTED_MODULE_4__["isEmpty"])(subItems)) {
    return null;
  }

  return __jsx("div", {
    className: "bg-white overflow-y-auto px-px50 py-px25",
    style: {
      maxHeight: _Navigation_constants__WEBPACK_IMPORTED_MODULE_5__[/* NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT */ "a"]
    }
  }, __jsx("ul", {
    className: "colum-count-5 column-gap-50 reset-list"
  }, subItems.map(function (item, index) {
    return __jsx("li", {
      className: "break-inside-avoid-column ".concat(index ? 'my-px15' : ''),
      "data-testid": "NavigationLargeSubNavList-sublist-item",
      key: item.label
    }, __jsx(_tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_7__[/* TrackClick */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, item.link, {
      as: _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"],
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("text-".concat(item.color), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, "focus:text-".concat(item.color, "-active hover:text-").concat(item.color, "-active"), !!item.color), 'font-bold font-sans reset-anchor focus:text-blue hover:text-blue text-md'),
      "data-testid": "NavigationLargeSubNavList-sublist-link"
    }), item.label), !Object(lodash__WEBPACK_IMPORTED_MODULE_4__["isEmpty"])(item.subItems) && __jsx("ul", {
      className: "mt-px15 reset-list"
    }, (item.subItems || []).map(function (subItem) {
      return __jsx("li", {
        key: subItem.label
      }, __jsx(_tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_7__[/* TrackClick */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, subItem.link, {
        as: _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"],
        className: "font-bold font-sans reset-anchor focus:text-blue hover:text-blue text-gray-darker text-sm",
        "data-testid": "NavigationLargeSubNavList-subsublist-link"
      }), subItem.label));
    })));
  })));
};

/***/ })

}]);